import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { ArticlePreview } from '../article-preview'
import Link from 'next/link'
import { SponsorBanner } from '../sponsor-banner'

import styles from './styles.module.scss'
import { Article } from 'types/article'
import { AdsIndexDto } from 'types/ads'

export type HeaderButton = {
  text?: string
  onClick?: () => void
}

interface SidebarArticlesPreviewProps {
  articles?: Article[]
  articlesSecondaries?: Article[]
  header?: {
    left?: HeaderButton
    right?: HeaderButton
  }
  showMoreLink?: string
  className?: string
  ads?: AdsIndexDto[]
}

export const SidebarArticlesPreview = ({
  articles = [],
  articlesSecondaries = [],
  header: { left = {}, right = {} } = {},
  showMoreLink,
  className,
  ads = []
}: SidebarArticlesPreviewProps): JSX.Element => {
  const [isLeftActived, setLeftActived] = useState(true)
  const [currentArticles, setCurrentArticles] = useState<Article[]>(articles)

  useEffect(() => {
    articles && setCurrentArticles(articles)
  }, [articles])

  return (
    <div className={className}>
      <SponsorBanner ads={ads} code="ad_sponsor_news_top_right" />

      <div
        className={`${articlesSecondaries.length > 0 && 'justify-around flex'}`}
      >
        <button
          className={
            classnames(styles.button) +
            `text-sm pb-1.5 pt-2 text-[11px] leading-4 tracking-[1.2px] rounded-full px-4 md:px-6 transition-all duration-300 ${
              isLeftActived
                ? 'border-transparent bg-gradient-to-r from-[#ffc25f] to-[#ff9c00] hover:brightness-105'
                : 'bg-white shadow-[inset_0_0_0_1px_black] hover:bg-gradient-to-r hover:from-[#ffc25f] hover:to-[#ff9c00] text-gray-700 p-4 transition'
            }`
          }
          type="button"
          onClick={() => {
            left?.onClick && left.onClick()
            setLeftActived(true)
            setCurrentArticles(articles)
          }}
        >
          {left?.text || 'Últimas notícias'}
        </button>
        {articlesSecondaries.length > 0 && (
          <button
            className={
              classnames(styles.button) +
              `text-sm pb-1.5 pt-2 text-[11px] leading-4 tracking-[1.2px] rounded-full px-4 md:px-6 transition-all duration-300 ${
                !isLeftActived
                  ? 'border-transparent bg-gradient-to-r from-[#ffc25f] to-[#ff9c00] hover:brightness-105'
                  : 'bg-white shadow-[inset_0_0_0_1px_black] hover:bg-gradient-to-r hover:from-[#ffc25f] hover:to-[#ff9c00] text-gray-700 p-4 transition'
              }`
            }
            type="button"
            onClick={() => {
              right?.onClick && right.onClick()
              setLeftActived(false)
              setCurrentArticles(articlesSecondaries)
            }}
          >
            {right?.text || 'Mais lidas'}
          </button>
        )}
      </div>
      <div>
        {currentArticles.map(
          ({
            id,
            title,
            articleType,
            videoUrl,
            publishedAt,
            editorial,
            editorialAscendent,
            timeToRead,
            path
          }) => (
            <ArticlePreview
              articlePath={path}
              className={styles.article}
              key={id}
              title={title}
              date={new Date(publishedAt).toLocaleDateString('pt-BR')}
              badge
              editorial={
                editorialAscendent ? editorialAscendent.name : editorial.name
              }
              editorialPath={
                editorialAscendent ? editorialAscendent.path : editorial.path
              }
              readingTime={`${timeToRead}`}
              videoUrl={videoUrl}
              articleType={articleType}
            />
          )
        )}
      </div>
      {showMoreLink && (
        <div className={styles.footer}>
          <Link
            href={showMoreLink}
            className="hover:bg-gray-100 rounded-full border px-2 py-1 text-gray-400"
          >
            Ver mais
          </Link>
        </div>
      )}
    </div>
  )
}
